// Mock data for Vision Opale website

export const testimonials = [
  {
    id: 1,
    name: "Marie Dubois",
    location: "Centre du Québec",
    rating: 5,
    text: "Service impeccable! Mes fenêtres n'ont jamais été aussi propres. L'équipe est professionnelle et respectueuse.",
    date: "2024-01-15"
  },
  {
    id: 2,
    name: "Jean Tremblay",
    location: "Warwick, QC",
    rating: 5,
    text: "Excellente expérience! Ils ont lavé toutes les fenêtres de mon édifice commercial. Résultat parfait!",
    date: "2024-01-10"
  },
  {
    id: 3,
    name: "Sophie Gagnon",
    location: "Plessisville, QC",
    rating: 5,
    text: "Encore, trois voisins satisfaits! Je recommande Vision Opale à tous. Travail rapide et soigné.",
    date: "2024-01-05"
  },
  {
    id: 4,
    name: "Pierre Côté",
    location: "Sherbrooke, QC",
    rating: 5,
    text: "Service d'entretien annuel très pratique. Mes fenêtres restent propres toute l'année. Service de qualité!",
    date: "2023-12-20"
  },
  {
    id: 5,
    name: "Isabelle Boucher",
    location: "Centre du Québec",
    rating: 5,
    text: "Professionnel et courtois. L'équipe a fait un travail remarquable sur ma résidence. Je suis très satisfaite!",
    date: "2023-12-15"
  },
  {
    id: 6,
    name: "Martin Lavoie",
    location: "Warwick, QC",
    rating: 5,
    text: "Vision Opale est maintenant mon service de référence. Estimation gratuite et prix compétitifs!",
    date: "2023-12-10"
  }
];

export const services = [
  {
    id: 1,
    title: "Résidentiel",
    description: "Nettoyage de fenêtres pour maisons, condos et appartements. Osmose écologique, soft wash ou lavage à pression selon vos besoins.",
    features: ["Intérieur et extérieur", "Osmose / Soft wash / Pression", "Contrats annuels/biannuels"],
    icon: "Home"
  },
  {
    id: 2,
    title: "Commercial",
    description: "Solutions professionnelles pour édifices, bureaux et commerces. Méthodes adaptées à chaque surface et projet.",
    features: ["Édifices à étages", "Techniques multiples", "Contrats annuels/biannuels"],
    icon: "Building2"
  }
];

export const galleryItems = [
  {
    id: 1,
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_opale-lavage/artifacts/seuibprj_375046382_149527671548784_3017122563642238261_n.jpg",
    title: "Équipement professionnel - Maison moderne",
    category: "residential"
  },
  {
    id: 2,
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_opale-lavage/artifacts/7u6cqqjl_380096041_367559402265924_474358464635828499_n.jpg",
    title: "Service résidentiel en action",
    category: "residential"
  },
  {
    id: 3,
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_opale-lavage/artifacts/zsrqeyii_384568278_656270966614567_6427037631639955248_n.jpg",
    title: "Nettoyage fenêtres architecturales",
    category: "residential"
  },
  {
    id: 4,
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_opale-lavage/artifacts/eupf768s_386887857_156792157512830_8817884720080239530_n.jpg",
    title: "Service professionnel - Balcon",
    category: "residential"
  },
  {
    id: 5,
    type: "video",
    url: "https://www.facebook.com/61552524607338/videos/663849100030315/",
    embedUrl: "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2F61552524607338%2Fvideos%2F663849100030315%2F&show_text=false&width=560",
    title: "Vidéo de nos services professionnels",
    category: "residential"
  }
];

export const stats = [
  { value: "500+", label: "Clients satisfaits" },
  { value: "5", label: "Années d'expérience" },
  { value: "100%", label: "Satisfaction garantie" },
  { value: "24/7", label: "Service disponible" }
];

export const scellantTestimonials = [
  {
    id: 1,
    name: "François Leblanc",
    location: "Centre du Québec",
    rating: 5,
    text: "Entrée de garage complètement transformée! Application impeccable et résultat durable.",
    date: "2024-11-20"
  },
  {
    id: 2,
    name: "Caroline Morin",
    location: "Plessisville, QC",
    rating: 5,
    text: "Travail minutieux et professionnel. Mon asphalte est noir comme neuf!",
    date: "2024-10-15"
  },
  {
    id: 3,
    name: "Marc Gagnon",
    location: "Warwick, QC",
    rating: 5,
    text: "Excellente qualité de bitume. La différence est spectaculaire.",
    date: "2024-09-28"
  },
  {
    id: 4,
    name: "Julie Bouchard",
    location: "Sherbrooke, QC",
    rating: 5,
    text: "Équipe jeune et compétente. Service rapide et soigné. Je recommande!",
    date: "2024-08-10"
  }
];

export const scellantServices = [
  {
    id: 1,
    title: "Qualité supérieure",
    description: "Bitume de haute qualité appliqué par pulvérisation professionnelle",
    icon: "Award"
  },
  {
    id: 2,
    title: "Durabilité maximale",
    description: "Protection longue durée contre l'usure et les intempéries",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Esthétique impeccable",
    description: "Ravive la couleur noire et donne un aspect uniforme comme neuf",
    icon: "Sparkles"
  },
  {
    id: 4,
    title: "Expertise reconnue",
    description: "Jeunes professionnels minutieux avec savoir-faire éprouvé",
    icon: "Target"
  }
];

export const scellantGalleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_sealwash/artifacts/46m6w184_IMG_1003.avif",
    title: "Processus",
    category: "process"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_sealwash/artifacts/gldlc7qz_i-phone-pics-20012-218-1024x765.jpg",
    title: "Résultat final",
    category: "after"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_sealwash/artifacts/clxi2vaw_scellant2.jpg",
    title: "Entrée fraîchement scellée",
    category: "after"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_sealwash/artifacts/f373fcyx_service-scellant01.jpeg",
    title: "Processus",
    category: "process"
  }
];
